'use client'
import { useIndustriesNavbarScroll } from '@/Hooks'
import React from 'react'
import IndHeroSection from './components/IndHeroSection'
import IndSectionTwo from './components/IndSectionTwo'
import FiFromStrategy from './components/FiFromStrategy'
import {
   ContactUsForm,
   FAQs,
   GameChangingIdea,
   WordsOfAppreciation,
} from '@/components'
import TravelWhyChoose from './components/TravelWhyChoose'
import RestHospThree from './components/RestHospThree'
import BusinessModels from './components/BusinessModels'

const faqData = [
   {
      question:
         'What is restaurant and hospitality software development, and why is it important?',
      answer:
         'It’s just building stuff restaurants and hotels actually need — like a POS that doesn’t lag, a menu people can actually scroll, or a booking tool that doesn’t break when it’s busy. It’s meant to make everyday stuff less of a headache for the staff and smoother for the customer.',
   },
   {
      question:
         'How can restaurant management software improve operational efficiency?',
      answer:
         'It helps run the place without needing to track everything by hand. You can keep track of tables, orders, scheduling, and stock without jumping between systems. You get fewer screw-ups, service moves faster, and your team isn’t stuck behind a screen the whole time. They can just do their job and pay attention to the people sitting in front of them.',
   },
   {
      question: 'What elements must a bespoke restaurant mobile app have?',
      answer:
         'It should let people check the menu easily, follow their order in real time, pay fast, earn loyalty points, get local offers, and maybe get a quick heads-up if something’s delayed. Just stuff that makes the app actually helpful. It should feel simple for customers and useful for your staff.',
   },
   {
      question:
         'What are the benefits of implementing a cloud-based POS system for restaurants?',
      answer:
         'You can take orders fast, handle any payment method, and check your sales from anywhere — even if you’re not in the restaurant. It keeps you in the loop without having to be on-site all the time. It also links to your delivery apps, customer database, and inventory, so you’re not switching between systems all day.',
   },
   {
      question:
         'How does AI-powered hospitality software enhance customer experience?',
      answer:
         "AI watches what people like, suggests stuff they might want, helps answer questions faster, and spots trends in what's popular. It relieves some of the team's workload and gives the visitor a more intimate experience.",
   },
   {
      question:
         'How does online food ordering and delivery software help restaurants grow?',
      answer:
         'It gives customers a simple way to order and track food online. You get paid securely, see what’s working through customer data, and reach more people without needing a big delivery team of your own.',
   },
   {
      question:
         'What is the importance of contactless dining and self-ordering kiosks in modern restaurants?',
      answer:
         'Self-order stations and QR menus allow customers to place orders and pay instantly. They cut down on mistakes, speed things up, and help keep everything clean — all while giving guests a more relaxed, modern dining experience.',
   },
   {
      question:
         'How does hotel booking and reservation software improve guest experiences?',
      answer:
         'It lets guests check what rooms are free, book easily, pay online, and check in without hassle. Automation and smart suggestions make the stay smoother and help hotel staff manage everything more efficiently.',
   },
   {
      question:
         'What are the key security features in hospitality software development?',
      answer:
         'Good hospitality software keeps data safe with things like fraud alerts, PCI-DSS standards, strong encryption, and GDPR rules. Secure payments and user logins build trust and keep you covered on the legal side too.',
   },
   {
      question:
         'How can Benzatine help businesses with restaurant and hospitality software development?',
      answer:
         'We build software that fits your setup. Whether it’s for managing tables, deliveries, bookings, or payments, we connect it all in one place and make sure it works smoothly. You focus on service — we handle the tech.',
   },
];

function RestaurantsAndHospitalityPage() {
   useIndustriesNavbarScroll()

   return (
      <>
         <IndHeroSection />
         <IndSectionTwo />

         <RestHospThree />
         <FiFromStrategy />
         <BusinessModels />

         <TravelWhyChoose />

         <GameChangingIdea />
         <section className="section appreciation-slider-section page_top_section section_secondary_bg">
            <WordsOfAppreciation />
         </section>

         <FAQs faqsConst={faqData} />

         <ContactUsForm />
      </>
   )
}

export default RestaurantsAndHospitalityPage
